// extracted by mini-css-extract-plugin
export var container = "_q5-0";
export var dotAnimation = "_q5-2";
export var dotsLoading = "_q5-1";